module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-800italic.1624214.woff2";